module.exports = __webpack_public_path__ + "img/RDA_tipo1_flexi-4pax_55m2.8b0f6ebd.png";